import React, { lazy, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, redirect, useLocation, } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import Leads from '../../pages/Leads';
import ICALEADS from '../../components/ICAModule/IcaLeads/ICALEADS';
import ICASearch from '../../components/ICAModule/IcaLeadSearch/ICASearch';
import Home from '../../pages/Home';
import Agents from '../../pages/Agents';
import Super_Admin_Agents from '../../pages/SuperAdmin_Agent_ICA/Super_Admin_Agents';
import Super_admin_ICA from '../../pages/SuperAdmin_Agent_ICA/Super_admin_ICA';
import Dashboard from '../../pages/Dashboard';
import AdminLeads from '../../pages/AdminLeads';
import InvitedLeads from '../../pages/InvitedLeads'
import ISAAgents from '../../pages/ISAAgent';
import ISAAgentsDetails from '../../pages/ISAAgentDetails';
import AgentsDetails from '../../pages/AgentsDetails';
import AdminLeadsDetails from '../../pages/AdminLeadsDetails';
import LoginForm from '../../pages/login';
import People from '../../pages/Admin/People';
import DummyScoreCard from '../../pages/DummyScoreCard';
import ForgotPasswordForm from '../../pages/ForgotPassword';
import OTPForm from '../../pages/Opt';
import ResetPasswordFoirm from '../../pages/ResetPassord';
import AdminChat from '../../pages/AdminChatModule/AdminChat';
import AdminComplaint from '../../pages/AdminComplaint/AdminComplaint';
import Scheduling from '../../pages/Scheduling/Scheduling';
import CustomersAdmin from '../../pages/CRM/CustomersAdmin';
import CustomerAdminDetails from '../../pages/CRM/CustomerAdminDetails';
import JobsAdmin from '../../pages/CRM/AdminJobs';
import OrganizationCustomer from '../../pages/OrganizationCustomer/OrganizationCustomer';
import AdminJobDetails from '../../pages/CRM/AdminJobDetails';
import ViewAllJobRoutes from '../../pages/CRM/ViewAllJobRoutes';
import ServicesJobDetails from '../../pages/CRM/ServicesJobDetails';
import Signup from '../../pages/ICALoginPages/Signup';
import ICALogin from '../../pages/ICALoginPages/ICALogin';
import ServicesMenu from '../../pages/ServicesMenu/ServicesMenu';
import AllLocation from '../../pages/PreferredLocation/AllLocation';
import AdminAlerts from '../../pages/Alerts/AdminAlerts';
import IcaChat from '../../components/ICAModule/IcaChat/IcaChat';
import ICAChatModule from '../../components/ICAModule/IcaChat/ICAChatModule';
import IcaDashboard from '../../components/ICAModule/IcaDashboard/IcaDashboard'
import IcaLeadTracking from '../../components/ICAModule/IcaDashboard/IcaLeadTracking'
import SwitchAgent from '../../pages/SwitchAgents/SwitchAgent';
import SwitchAgentsDetails from '../../pages/SwitchAgents/SwitchAgentsDetails';
import PromoMessage from '../../pages/PromoMessage/PromoMessage';
import CustomNotification from '../../pages/CustomNotification/CustomNotification';
import AdminVersion from '../../pages/AdminVersion/AdminVersion';
import ICAAlerts from '../../components/ICAModule/ICAAlerts/ICAAlerts';
import UserProfileCard from '../../marketingCall/UserProfileCard'
import ReferralAgent from '../../pages/ReferralAgent/ReferralAgent';
import ReferralAgentDetails from '../../pages/ReferralAgent/ReferralAgentDetails';
import RoutesLogout from './RoutesLogout';
import GetParentReferral from '../../pages/ReferralPage/GetParentReferral';
import GetParentChild from '../../pages/ReferralPage/GetParentChild';
import SalesLogin from '../../components/SaleModule/SalesLogin/SalesLogin';
import SalesUsers from '../../components/SaleModule/SalesUsers/SalesUsers';
import GetParentSubChild from '../../pages/ReferralPage/GetParentSubChild';
import GetSalesAgents from '../../components/SaleModule/CreateSaleAgent/GetSalesAgents';
export function ProtectedRoute({ children }) {
    const location = useLocation();
    const auth = useSelector((state) => state.auth.isAuthenticated);

    if (!auth.isAuthenticated && !auth?.user?.user_type) {
        const redirectUrl = location.pathname;
        window.localStorage.setItem('redirectURL', redirectUrl);
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}

export const GetRoutes = (isAuthenticated, user) => {
    const [routesLogout, setRoutesLogout] = useState(false)
    const [locationPath, setLocationPath] = useState('')
    const location = useLocation(); // Access current location
    useEffect(() => {
        // Capture initial location if conditions match
        if (user?.user_type === 'isa_agent' && location.pathname.startsWith("/tapTalkTour/")) {
            debugger
            setRoutesLogout(true);
            setLocationPath(location.pathname);
            return
        } else if (user?.user_type === 'admin' && location.pathname.startsWith("/tapTalkTour/")) {
            debugger
            setRoutesLogout(true);
            setLocationPath(location.pathname);
            return
        } else if (user?.user_type === 'organization_admin' && location.pathname.startsWith("/tapTalkTour/")) {
            setRoutesLogout(true);
            setLocationPath(location.pathname); // Store the current path
            return
        }
    }, [user, location]);

    if (routesLogout) {
        debugger
        return (
            <RoutesLogout
                routesLogout={routesLogout}
                setRoutesLogout={setRoutesLogout}
                locationPath={locationPath}
                setLocationPath={setLocationPath}
            />
        );
    }

    if (!isAuthenticated || !user) {
        return (
            <Routes>
                <Route path="/login" element={<LoginForm />} />
                <Route path="/ica-login" element={<ICALogin />} />
                <Route path="/sales-login" element={<SalesLogin/>} />
                <Route path="/tapTalkTour/:id" element={<UserProfileCard />} />
                <Route path="/forgot-password" element={<ForgotPasswordForm />} />
                <Route path="/otp" element={<OTPForm />} />
                <Route path="/reset-password" element={<ResetPasswordFoirm />} />
                <Route path="*" element={<LoginForm />} />

            </Routes>
        );
    } else if (user.user_type === 'isa_agent') {
        // // if (location.pathname.startsWith("/iconnctAdminPanel/tapTalkTour/")) {
        // if (location.pathname.startsWith("/tapTalkTour/")) {
        //     setRoutesLogout(true)
        //     return setLocationPath(location.pathname)

        //     // localStorage.clear();
        //     // sessionStorage.clear();

        //     // // Force cache bypass by appending a query parameter
        //     // window.location.reload(true); // Force reload bypassing cache

        //     // // Redirect to the clean URL without dynamic params
        //     // return <Navigate to={location.pathname} replace />;

        // }
        return (
            <Routes>
                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/" element={<IcaDashboard />} />
                <Route path="/ica-tracking/:id" element={<IcaLeadTracking />} />
                <Route path="/map" element={<Leads />} />
                <Route path="/get-leads" element={<ICALEADS />} />
                <Route path="/ica-search" element={<ICASearch />} />
                <Route path="/ica-chat" element={<ICAChatModule />} />
                <Route path="/ica-alerts" element={<ICAAlerts />} />
            </Routes>
        );
    }
    else if (user.user_type === 'admin') {
        return (
            <Routes>

                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/" element={<OrganizationCustomer />} />
                <Route path="PreferredLocation" element={<AllLocation />} />
                <Route path="/jobs" element={<JobsAdmin />} />
                <Route path="admin-job-details/:id" element={<AdminJobDetails />} />
                <Route path="admin-Services-details/:id" element={<ServicesJobDetails />} />
                <Route path="/ServicesMenu" element={<ServicesMenu />} />
                <Route path="/customers" element={<CustomersAdmin />} />
                <Route path="customers-details/:id" element={<CustomerAdminDetails />} />
                <Route path="/organization-agent" element={<Super_Admin_Agents />} />
                <Route path="/organization-ICA" element={<Super_admin_ICA />} />
                <Route path="/agents-details/:id" element={<AgentsDetails />} />
                <Route path="/complaint" element={<AdminComplaint />} />
                <Route path="/promoMessage" element={<PromoMessage />} />
                <Route path="/adminVersion" element={<AdminVersion />} />
                <Route path="/customNotification" element={<CustomNotification />} />
                {/* <Route path="/referralAgent" element={<ReferralAgent />} /> */}
                {/* <Route path="/referralAgentDetails/:ref" element={<ReferralAgentDetails />} /> */}
                <Route path="/referral-sales" element={<GetParentReferral />} />
                <Route path="/referralSalesDetails/:parentId" element={<GetParentChild />} />
                <Route path="/referralSubChild/:id" element={<GetParentSubChild />} />
            </Routes>
        );
    }
    else if (user.user_type === 'sales') {
        return (
            <Routes>

                {/* <Route path="*" element={<Navigate to="/" />} /> */}
                <Route path="/" element={<SalesUsers />} />
                <Route path="/new-sale-users" element={<GetSalesAgents />} />
                <Route path="/referral-sales" element={<GetParentReferral />} />
                <Route path="/referralSalesDetails/:parentId" element={<GetParentChild />} />
                <Route path="/referralSubChild/:id" element={<GetParentSubChild />} />

            </Routes>
        );
    }
    else if (user.user_type === 'organization_admin') {
        return (
            <Routes>
                {/* <Route path="/" element={<Home />} /> */}
                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/dummy-scoreboard" element={<DummyScoreCard />} />
                <Route path="/agents" element={<Agents />} />
                <Route path="/ica-agents" element={<ISAAgents />} />
                <Route path="/switch-agent" element={<SwitchAgent />} />
                <Route path="/switch-agent-details/:id" element={<SwitchAgentsDetails />} />
                <Route path="/isa-agent-details/:id" element={<ISAAgentsDetails />} />
                <Route path="/agents-details/:id" element={<AgentsDetails />} />
                <Route path="/people" element={<People />} />
                <Route path="/admin-Leads" element={<AdminLeads />} />
                <Route path="/invited-leads" element={<InvitedLeads />} />
                <Route path="admin-leads-details/:id" element={<AdminLeadsDetails />} />
                <Route path="/admin-chat" element={<AdminChat />} />
                <Route path="/Scheduling" element={<Scheduling />} />
                <Route path="ViewAllJobRoutes" element={<ViewAllJobRoutes />} />
                <Route path="Admin-Alerts" element={<AdminAlerts />} />

                {/* Dashboard */}
                <Route path="/" element={<Dashboard />} />
            </Routes>
        );
    }
    else {
        <Route path="*" element={<Navigate to="/" />} />
    }



};
